console.log('Main.ts is starting...');

// import { bootstrapApplication } from '@angular/platform-browser';
// import { AppComponent } from './app/app.component';
// import { provideRouter } from '@angular/router';
// import { provideHttpClient, withFetch } from '@angular/common/http';
// import { MenuComponent } from './app/menu/menu.component';
// import { ReviewComponent } from './app/review/review.component';
// import { AboutComponent } from './app/about/about.component';
// import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
// import { CreatemymenuComponent } from './app/createmymenu/createmymenu.component';
// import { MarriagemenuComponent } from './app/marriagemenu/marriagemenu.component';
// import { HomeComponent } from './app/home/home.component';
// import { MobilemarriagemenuComponent } from './app/mobilemarriagemenu/mobilemarriagemenu.component';
// import { MobileoptionsComponent } from './app/mobileoptions/mobileoptions.component';
// import { routes } from './app/app.routes';
// import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
// import { provideFirestore, getFirestore } from '@angular/fire/firestore';
// import { environment } from './environments/environment';
// import { FIREBASE_OPTIONS } from '@angular/fire/compat';
// import { ApplicationConfig, importProvidersFrom } from '@angular/core';



// bootstrapApplication(AppComponent,{
//   providers: [
//     provideRouter(routes),
//     provideHttpClient(withFetch()), provideAnimationsAsync(),
//     provideFirebaseApp(() => initializeApp(environment.firebase)),
//     provideFirestore(() => getFirestore()),
//     { provide: FIREBASE_OPTIONS, useValue: environment.firebase }
   
   
//   ]
// }).catch(err => console.error(err));
(window as any).global = window;
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app/app.routes';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { environment } from './environments/environment';
import { FIREBASE_OPTIONS } from './app/firebaase-option.token'; // Use your local token
//import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { getAuth, provideAuth } from '@angular/fire/auth';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    //  provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase }
  ]
}).catch(err => console.error(err));